import $ from 'jquery';

$(function () {
	if ($('.is-loading').length) {
		// $('.is-loading').removeClass('is-loading')
	}
})
